/*
 * Copyright (c) 2016-2022 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
// TC39 Decorators proposal
export const classStandardDecorator = (value, descriptor, fn) => {
    const { kind, elements } = descriptor;
    return {
        kind,
        elements,
        finisher(classDef) {
            fn(value, classDef);
        },
    };
};
// Legacy TS Decorator
export const classLegacyDecorator = (value, classDef, fn) => {
    fn(value, classDef);
    return classDef;
};
